import React from 'react';
import styled, { keyframes } from 'styled-components';
import { translate } from '../../Services/translation';
import { breakpoint } from '../../styling/mixins/breakpoints';
import { getColor } from '../../styling/mixins/colors';
import { fontFamilyBold, text } from '../../styling/mixins/typography';
import LipscoreRating from '../Lipscore/LipscoreRating';
import {
  REVIEWS_TYPE,
  SPECIFICATION_TAB
} from './ProductTabsConstants';

const StyledProductTabsMenu = styled.div`
  padding-left: 3.2rem;
  display: flex;
  justify-content: flex-start;
  overflow-x: auto;
  background-color: ${getColor('gray', 100)};
  ${breakpoint('xlarge')} {
    padding-left: 0;
    justify-content: center;
  }
`;
const borderAnimation = keyframes`
	0%{
		width: 0%;
	}
	100%{
		width: 100%;
	}
`;

const StyledMenuItem = styled.div`
  position: relative;
  white-space: nowrap;
  padding: 1.6rem;
  ${text('large')};
  ${fontFamilyBold};
  transition: background-color 0.3s ease-in;
  color: ${getColor('gray', 600)};
  &:hover {
    cursor: pointer;
    background-color: #ffffff80;
    &:after {
      animation: ${borderAnimation} 0.2s ease-in forwards;
    }
  }
  &:after {
    position: absolute;
    width: 0%;
    bottom: 0;
    left: 0;
    right: 0;
    content: '';
    height: 2px;
    background-color: #d2551f80;
  }
  &.tab-active {
    background: ${getColor('white')};
    color: ${getColor('gray', 900)};
    &:after {
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
      right: 0;
      content: '';
      height: 2px;
      background-color: ${getColor('primary')};
    }
    &:hover {
      &:after {
        animation: none;
      }
    }
  }
`;

const StyledLipscoreRatingContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`;


const ProductTabsMenu = ({
  tabItems,
  setActiveTab,
  activeTab,
  specifications
}) => {
  return (
    <StyledProductTabsMenu>
      {tabItems.map(({ key, value, label }) => {
        const tabKey = `${key}_tab`.toUpperCase();
        return (
          <StyledMenuItem
            className={activeTab === tabKey ? 'tab-active' : ''}
            onClick={() => setActiveTab(tabKey)}
          >
            {key.toUpperCase() === REVIEWS_TYPE ? (
              <StyledLipscoreRatingContainer>{label}
                <LipscoreRating {...value} setActiveTab={setActiveTab} readOnly={true} />
              </StyledLipscoreRatingContainer>
            ) : (label)}
          </StyledMenuItem>
        );
      })}
      {specifications?.productFields?.length >= 1 && (
        <StyledMenuItem
          className={activeTab == SPECIFICATION_TAB ? 'tab-active' : ''}
          onClick={() => setActiveTab(SPECIFICATION_TAB)}
        >
          {translate('product-tabs.specification')}
        </StyledMenuItem>
      )}
    </StyledProductTabsMenu>
  );
};

export default ProductTabsMenu;
